<div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
  <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
    <h2 class="noMarginHeader">
      <mat-icon>bar_chart</mat-icon> Wells with vouchers missing Lat/Long
    </h2><br />
  </div>
</div>
<div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
  <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
    <small>Any Well tied to a Voucher that is missing Lat/Long values. </small><br />
  </div>
</div>

<mat-card *ngIf="loading">
  <span>Loading</span><br />
  <mat-progress-bar mode="query"></mat-progress-bar>
</mat-card>

<!-- List of Letter Tasks -->
<mat-card>
  <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
    <br />
    <strong class="noMarginHeader">Total ({{size}})</strong>
    <br /><br />
    <mat-table [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8"
      style="overflow-x: auto;">
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      <ng-container matColumnDef="wellId">
        <mat-header-cell *matHeaderCellDef mat-sort-header>OHA Well Id</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.wellId}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellAddress1">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Well Address</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.wellAddress1}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellCity">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Well City</mat-header-cell>

        <mat-cell *matCellDef="let result">
          {{result.wellCity}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellZip">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Well Zip</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.wellZip}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="wellCounty">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Well County</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.wellCounty}}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef mat-sort-header>&nbsp;</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <a href="javascript:void(0)" (click)="findLatLong(result.wellId)"
            title="Lookup Lat/Long for {{result.wellId}}">Lookup Lat/Long</a>

        </mat-cell>
      </ng-container>
    </mat-table>
    <br />
    <mat-paginator [pageSizeOptions]="[10, 20, 50]" #TablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
  </div>
</mat-card>